import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { map, take } from 'rxjs/operators';
import { ResourceType, TemplateType } from '../../../../../core/enums';
import { Resource } from '../../../../../core/models';
import { ProcessNavigatorService } from '../../../../../core/services/process-navigator.service';

@Component({
  selector: 'kt-add-process-nav-resource',
  templateUrl: './add-process-nav-resource.component.html',
})
export class AddProcessNavResourceComponent {
  ResourceType = ResourceType;
  form = this.formBuilder.group({
    urlLink: [''],
    videoLink: [''],
    pdfPath: [''],
  });
  resources: Partial<Resource>[];
  @Input() templateType: TemplateType;
  @Output() addedResources = new EventEmitter<Partial<Resource>[]>();
  @Input() mode;

  private _templateId: number;
  @Input() set templateId(value: number) {
    if (!value) {
      this.resources = [];
      this.form.patchValue({
        urlLink: '',
        videoLink: '',
        pdfPath: '',
      });

      return;
    }
    this._templateId = value;
    this.loadResources(value);
  }

  get templateId(): number {
    return this._templateId;
  }

  private _emitResources: boolean;
  @Input() set emitResources(value: boolean) {
    if (value) this.addedResources.emit(this.resources);
  }

  get emitResources(): boolean {
    return this._emitResources;
  }

  constructor(
    private formBuilder: FormBuilder,
    private processNavService: ProcessNavigatorService,
  ) {}

  addResource(type: ResourceType): void {
    const formValue = this.form.value;
    const path =
      type === ResourceType.HTML
        ? formValue.urlLink
        : type === ResourceType.PDF
        ? formValue.pdfPath
        : formValue.videoLink;

    this.resources = [
      ...this.resources?.filter((resource) => resource.type !== type),
      { ...this.resources?.find((resource) => resource.type === type), type, path },
    ];
    this.resources = this.resources.filter((x) => x.path !== '');
    this.processNavService
      .createUpdateResources(this._templateId, TemplateType.TASK_TEMPLATE, this.resources)
      .subscribe();
  }

  uploadFile(event: Event): void {
    const target = event.target as HTMLInputElement;

    if (target?.files && target.files?.length) {
      const file = target.files[0];

      this.processNavService
        .createPreSigned(file.name)
        .pipe(take(1))
        .subscribe(({ data }) => {
          this.form.get('pdfPath')?.patchValue(data.uuid);

          this.processNavService
            .upload(data.url, file)
            .pipe(take(1))
            .subscribe((res) => {
              if (!res.ok) return;

              this.addResource(ResourceType.PDF);
            });
        });
    }
  }

  getFilename(path: string): string {
    const filename = path?.substring(path?.lastIndexOf('/') + 1);

    return filename?.substring(0, filename?.toLowerCase().indexOf('.pdf')) || '';
  }

  removeFile(event: Event): void {
    event.stopPropagation();

    this.form.get('pdfPath')?.patchValue('');
    this.addResource(ResourceType.PDF);
  }

  loadResources(templateID) {
    this.processNavService
      .getResources(templateID, this.templateType)
      .pipe(
        take(1),
        map((res) => res.data),
      )
      .subscribe((resources) => {
        this.resources = resources || [];
        this.form.patchValue({
          urlLink: this.resources.find((resource) => resource.type === ResourceType.HTML)?.path,
          videoLink: this.resources.find((resource) => resource.type === ResourceType.VIDEO_LINK)
            ?.path,
          pdfPath: this.resources.find((resource) => resource.type === ResourceType.PDF)?.path,
        });
        // View Mode
        if (this.mode === 'view') this.form.disable();
      });
  }
}
